import { describeRunResult } from '@sorrem-client/game/run-result-description';
import { Button, Notification } from '@sorrem-client/ui/components';
import { CutscenePlayer } from '@sorrem-client/ui/features/Cutscene';
import { useAfterRunCutscene } from '@sorrem-client/ui/features/GameOverlay/hooks';
import { useGameplay } from '@sorrem-client/ui/features/PlayPage/gameplay-context';
import { useGameSelector, useSelectedCharacterId } from '@sorrem-client/ui/hooks';
import { useLeaveRun } from '@sorrem-client/ui/features/PlayPage/use-leave-run';

/**
 * How the run ended. A run with an ending cutscene ends on it, back to
 * Character Home; one without shows the results notice.
 */
export function GameOverlayRunEnd(): JSX.Element | null {
    const leaveRun = useLeaveRun();
    const { bridge } = useGameplay();
    const runResult = useGameSelector(bridge, (state) => state.runResult);
    const { selectedCharacterId } = useSelectedCharacterId();
    const { afterCutsceneId, finish } = useAfterRunCutscene(runResult);

    if (afterCutsceneId !== null) {
        return <CutscenePlayer cutsceneId={afterCutsceneId} onFinished={finish} />;
    }
    if (runResult === null) {
        return null;
    }
    const { title, message } = describeRunResult(runResult, selectedCharacterId ?? '');
    return (
        <Notification title={title} message={message}>
            <Button onClick={() => { void leaveRun('home'); }}>Return to character</Button>
        </Notification>
    );
}
